export default "__VITE_ASSET__6a5b64dd__"